import { render, staticRenderFns } from "./SDKIntegration.vue?vue&type=template&id=2b3b7db5&scoped=true&"
import script from "./SDKIntegration.vue?vue&type=script&lang=js&"
export * from "./SDKIntegration.vue?vue&type=script&lang=js&"
import style0 from "./SDKIntegration.vue?vue&type=style&index=0&id=2b3b7db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b7db5",
  null
  
)

export default component.exports